// extracted by mini-css-extract-plugin
module.exports = {"questionsBgContainer":"QuestionsBgContainer_questionsBgContainer__Hd0ux","imageBox":"QuestionsBgContainer_imageBox__1cB7f"};